'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TwoFactorComponent = exports.DEFAULT = undefined;

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHyperscript = require('react-hyperscript');

var _reactHyperscript2 = _interopRequireDefault(_reactHyperscript);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _masonCanvas = require('../mason-canvas');

var _masonCanvas2 = _interopRequireDefault(_masonCanvas);

var _authy = require('../../integrations/authy');

var _authy2 = _interopRequireDefault(_authy);

var _withConfig = require('../withConfig');

var _withConfig2 = _interopRequireDefault(_withConfig);

var _store = require('../../store');

var _withErrorLogger = require('../withErrorLogger');

var _withErrorLogger2 = _interopRequireDefault(_withErrorLogger);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var DEFAULT = exports.DEFAULT = 'default';

var TwoFactorComponent = exports.TwoFactorComponent = function (_Component) {
  _inherits(TwoFactorComponent, _Component);

  function TwoFactorComponent() {
    _classCallCheck(this, TwoFactorComponent);

    return _possibleConstructorReturn(this, (TwoFactorComponent.__proto__ || Object.getPrototypeOf(TwoFactorComponent)).apply(this, arguments));
  }

  _createClass(TwoFactorComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!_lodash2.default.isEmpty(this.props.config) && !_lodash2.default.isEmpty(this.props.authyUserId)) {
        _authy2.default.send2FARequest(this.props.config, this.props.authyUserId).then(function (response) {
          return _this2.props.didReceiveData(response);
        });
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash2.default.isEqual(nextProps.config, this.props.config) || !_lodash2.default.isEqual(this.props.authyUserId, nextProps.authyUserId)) {
        _authy2.default.send2FARequest(nextProps.config, nextProps.authyUserId).then(function (response) {
          return nextProps.didReceiveData(response);
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return (0, _reactHyperscript2.default)(_masonCanvas2.default, this.props);
    }
  }]);

  return TwoFactorComponent;
}(_react.Component);

TwoFactorComponent.propTypes = {
  authyUserId: _propTypes2.default.string,
  config: _propTypes2.default.shape({
    data: _propTypes2.default.shape(_defineProperty({}, DEFAULT, _propTypes2.default.shape({
      tree: _propTypes2.default.object
    })))
  }),
  didReceiveData: _propTypes2.default.func
};
TwoFactorComponent.defaultProps = {
  authyUserId: '',
  config: {},
  didReceiveData: _lodash2.default.identity
};
exports.default = (0, _store.connectWithStore)((0, _withConfig2.default)((0, _withErrorLogger2.default)(TwoFactorComponent)));